import React from 'react'
import Border from './style'

const DashedBorder = () => <Border />

export default DashedBorder
